import { referralBaseModel } from './crud';

export * from './types';

export const useReferralsById = referralBaseModel.fetchById();
export const useReferralsByIds = referralBaseModel.fetchByIds();
export const useReferralsMany = referralBaseModel.fetchMany();
export const useReferralsCount = referralBaseModel.count();
export const useReferralsManyInfiniteQuery = referralBaseModel.fetchPaginated();
export const useReferralsUpdateOne = referralBaseModel.edit();
export const useReferralsCreateOne = referralBaseModel.create();
export const useReferralsRemoveOne = referralBaseModel.delete();
export const useReferralsRemoveByIds = referralBaseModel.deleteByIds();

export const useReferralsByIdV2 = referralBaseModel.fetchByIdV2();
export const useReferralsByIdsV2 = referralBaseModel.fetchByIdsV2();
export const useReferralsManyV2 = referralBaseModel.fetchManyV2();
export const useReferralsCountV2 = referralBaseModel.countV2();
export const useReferralsManyInfiniteQueryV2 =
  referralBaseModel.fetchPaginatedV2();
export const useReferralsUpdateOneV2 = referralBaseModel.editV2();
export const useReferralsCreateOneV2 = referralBaseModel.createV2();
export const useReferralsRemoveOneV2 = referralBaseModel.deleteV2();
export const useReferralsRemoveByIdsV2 = referralBaseModel.deleteByIdsV2();

// New names based on Mongoose queries
export const useReferralById = referralBaseModel.fetchById();
export const useReferralByIds = referralBaseModel.fetchByIds();
export const useReferralMany = referralBaseModel.fetchMany();
export const useReferralCount = referralBaseModel.count();
export const useReferralPagination = referralBaseModel.fetchPaginated();
export const useReferralUpdateOne = referralBaseModel.edit();
export const useReferralCreateOne = referralBaseModel.create();
export const useReferralRemoveOne = referralBaseModel.delete();
export const useReferralRemoveByIds = referralBaseModel.deleteByIds();

export const useReferralByIdV2 = referralBaseModel.fetchByIdV2();
export const useReferralByIdsV2 = referralBaseModel.fetchByIdsV2();
export const useReferralManyV2 = referralBaseModel.fetchManyV2();
export const useReferralCountV2 = referralBaseModel.countV2();
export const useReferralPaginationV2 = referralBaseModel.fetchPaginatedV2();
export const useReferralUpdateOneV2 = referralBaseModel.editV2();
export const useReferralCreateOneV2 = referralBaseModel.createV2();
export const useReferralRemoveOneV2 = referralBaseModel.deleteV2();
export const useReferralRemoveByIdsV2 = referralBaseModel.deleteByIdsV2();
